import React, { useState } from 'react';
import { IconChevronLeftOutline, IconChevronRightOutline } from '@zillow/constellation';
import * as S from './styles';

const Carousel = (props = {}) => {
  const [index, setIndex] = useState(0);
  const children = React.Children.toArray(props.children);
  const activeItem = children[index];

  const handleClick = (e, type) => {
    e.stopPropagation();
    e.preventDefault();
    const maxIndex = children.length - 1;
    let updateIndex = index;

    if (type === 'next') {
      updateIndex += 1;
    } else if (type === 'prev') {
      updateIndex -= 1;
    }

    if (updateIndex < 0) {
      updateIndex = maxIndex;
    } else if (updateIndex > maxIndex) {
      updateIndex = 0;
    }

    setIndex(updateIndex);
  };

  return (
    <S.Carousel>
      <S.PrevButton onClick={(e) => handleClick(e, 'prev')}>
        <IconChevronLeftOutline fontColor="gray300" size="lg" />
      </S.PrevButton>
      <S.ReviewWrapper>
        {activeItem}
        <S.DotContainer>
          {children.map((child, idx) => (
            <S.Dot active={idx === index} onClick={() => setIndex(idx)} key={idx} />
          ))}
        </S.DotContainer>
      </S.ReviewWrapper>
      <S.NextButton onClick={(e) => handleClick(e, 'next')}>
        <IconChevronRightOutline fontColor="gray300" size="lg" />
      </S.NextButton>
    </S.Carousel>
  );
};

export default Carousel;
